import colorSchemes from './ColorSchemes';
import constants from '../constants';

export default function getColorInRange(num, range) {
  let i = 0;
  const numClasses = range.length;

  
  for (i; i < range.length; i += 1) {
    console.log("min: " + range[i].min + " max: " + range[i].max);
    console.log("num: " + num);
    if (num >= range[i].min
        && num <= range[i].max) {
      if (numClasses < 3) {
        return constants.colorRamp.noDataColor;
      }
      const color = colorSchemes[constants.colorRamp.defaultColorScheme][numClasses][i];
      return color;
    }
  }

  return constants.colorRamp.noDataColor;
}



// WEBPACK FOOTER //
// ./src/components/LP/Maps/Classification/ColorScale.js